import axios from "axios";

export default {
  namespaced: true,

  state: {
    activity: []
  },

  actions: {
    getActivities: async ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/activity?size=500`,
          data: {},
          method: "GET"
        })
          .then(res => {
            if (res.data && res.data.content) {
              commit("updateActivity", res.data.content);
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    }
  },

  mutations: {
    updateActivity: (state, activities) => {
      state.activity = activities;
    }
  }
};
